import React, { useEffect, useState } from 'react';
import { Button, Card, Form, Modal, Table } from 'react-bootstrap';
import DataTable from 'react-data-table-component';
import { FaBan, FaCheck, FaPen, FaTimes, FaTrash, FaFilePdf, FaArrowDown, FaArrowUp } from 'react-icons/fa';
import CotisationNew from './CotisationNew';
import CotisationChoixCreate from './CotisationChoixCreate';
import GenerePdf from './GenerePdf';
import CotisationModif from './CotisationModif';
import CotisationChoixModif from './CotisationChoixModif';

const CotisationGere = () => {
    const [show, setShow] = useState(false);
    const [showUpdateCotisation, setShowUpdateCotisation] = useState(false);
    const [showChoix, setShowChoix] = useState(false);
    const [showModifChoix, setShowModifChoix] = useState(false);
    const [cotisationSel, setCotisationSel] = useState({});
    const [cotisations, setCotisations] = useState([]);
    const [searchText, setSearchText] = useState('');
    const [cotisationsFiltered, setcotisationsFiltered] = useState([]);
    const [data, setData] = useState({});
    const [goGenerePdf, setGoGenerePdf] = useState(false);
    const [feuilleParentSel, setFeuilleParentSel] = useState(0);

    const handleClose = () => setShow(false);
    const handleCloseUpdateCotisation = () => setShowUpdateCotisation(false);

    const url = localStorage.getItem('url');

    const filtreParent = (data, parent) => {
        return data.filter(item => item.parent === parent || item.id === parent);
    }
    const filtre = (value, data, parent) => {
        setSearchText(value);
        if (value.length < 1) {
            setcotisationsFiltered(filtreParent(data, parent));
        } else {
            const filtered = data.filter(item => {
                // must contains all word of value
                return value.split(' ').every(word => {
                    return JSON.stringify(item).toLowerCase().includes(word.toLowerCase());
                });
            });
            setcotisationsFiltered(filtreParent(filtered, parent));
            // console.log(filtered);
        }

    }

    const handleChangesearchText = (e) => {
        filtre(e.target.value, cotisations, feuilleParentSel);

    };

    const getCotisations = () => {
        fetch(`${url}GetCotisations/`)
            .then(response => response.json())
            .then(data => {
                setCotisations(data.data);
                setcotisationsFiltered(filtreParent(data.data, feuilleParentSel));
            })
            .catch(error => console.error('Erreur:', error));
    }

    useEffect(() => {
        getCotisations();
    }, []);

    const handleModifCotisation = (e, row) => {
        e.preventDefault();
        console.log('handleModifCotisation', row);
        setCotisationSel(row);
        setShowUpdateCotisation(true);
    }

    const handleSelParent = (e, row) => {
        e.preventDefault();
        console.log('handleSelParent', row);
        setFeuilleParentSel(row.id);
        filtre(searchText, cotisations, row.id);
    }
    const handleUnSelParent = (e) => {
        e.preventDefault();
        console.log('handleUnSelParent');
        setFeuilleParentSel(0);
        filtre(searchText, cotisations, 0);
    }
    const handleDel = (e, row) => {
        e.preventDefault();
        console.log('handleDel', row);
        if (window.confirm('Voulez-vous vraiment supprimer cette cotisation ?'))
            fetch(`${url}DelCotisation/${row.id}`)
                .then(response => response.json())
                .then(data => {
                    console.log('DelCotisation:', data);
                    getCotisations();
                })
                .catch(error => console.error('Erreur:', error));
    }

    const handleGenerePdf = (e, row) => {
        e.preventDefault();
        console.log('handleGenerePdf', row);
        let tableau1 = JSON.parse(row.choix);
        // row avec tableau1 dedans
        setData({ ...row, tableau1: tableau1, tableau_tribu: [{...row}] });
        setTimeout(() => {
            setGoGenerePdf(true);
        }, 500);
        // fetch(`${url}GenerePdfCotisation/${row.id}`)
        //     .then(response => response.json())
        //     .then(data => {
        //         console.log('pdf:', data);
        //         window.open(data.data, '_blank');
        //     })
        //     .catch(error => console.error('Erreur:', error));
    }

    const columns = [
        { name: 'Feuille', width: '120px', selector: row => row.reference, sortable: true, wrap: true },
        { name: 'Titre', selector: row => row.titre, sortable: true, wrap: true },
        { name: 'Libellé bloc cotisation', selector: row => row.libelle, sortable: true, wrap: true },
        { name: 'Tribu montant', width: '140px', selector: row => row.tribu_montant + ' €', sortable: true, wrap: true },
        { name: 'SIV montant', width: '140px', selector: row => row.siv_montant + ' €', sortable: true, wrap: true },
        { name: 'Trois fois', width: '100px', selector: row => row.trois_fois === 1 ? <FaCheck style={{ color: 'green' }} /> : <FaBan style={{ color: 'red' }} />, sortable: true, wrap: true },
        { name: 'Six fois', width: '100px', selector: row => row.six_fois === 1 ? <FaCheck style={{ color: 'green' }} /> : <FaBan style={{ color: 'red' }} />, sortable: true, wrap: true },


        // { name: 'Tribu trois fois', selector: row => row.tribu_trois_fois, sortable: true, wrap: true },
        // { name: 'Tribu six fois', selector: row => row.tribu_six_fois, sortable: true, wrap: true },
        // { name: 'Prélèvement trois fois', selector: row => row.prelevement_trois_fois, sortable: true, wrap: true },
        // { name: 'Prélèvement six fois', selector: row => row.prelevement_six_fois, sortable: true, wrap: true },

        // {
        //     name: 'Actions', width: '80px', cell: row => (<>
        //         <Button variant='secondary' onClick={() => handleShow(row)}><FaPen /></Button>
        //     </>),
        // },
        // {
        //     name: 'Suppr', width: '80px', cell: row => (<>
        //         <Button variant='danger' onClick={(e) => handleDel(e, row)}><FaTrash /></Button>
        //     </>),
        // },
        {
            name: 'Pdf', width: '80px', cell: row => (<>
                <Button variant='outline-danger' onClick={(e) => handleGenerePdf(e, row)}><FaFilePdf /></Button>
            </>),
        },
        {
            name: 'Modifier', width: '80px', cell: row => (<>
                <Button variant='outline-secondary' onClick={(e) => handleModifCotisation(e, row)}><FaPen /></Button>
            </>),
        },
        {
            name: 'Supprimer', width: '80px', cell: row => (<>
                {row.feuille_used === 0 &&
                    <Button variant='outline-danger' onClick={(e) => handleDel(e, row)}><FaTrash /></Button>
                }
            </>),
        },
        {
            name: 'Prorata', width: '80px', cell: row => (<>
                {row.parent === 0 && feuilleParentSel === 0 && cotisations.filter(el=>el.parent===row.id).length>0 &&
                    <Button variant='outline-warning' onClick={(e) => handleSelParent(e, row)}><FaArrowDown /></Button>
                }
                {row.parent === 0 && row.id === feuilleParentSel &&
                    <Button variant='outline-success' onClick={(e) => handleUnSelParent(e)}><FaArrowUp /></Button>
                }
            </>),
        },
    ];

    const [choix, setChoix] = useState([]);
    const [choixFiltered, setChoixFiltered] = useState([]);
    const [choixSel, setChoixSel] = useState({});
    const [cotisationIdSel, setCotisationIdSel] = useState('');
    const [maxordre, setMaxordre] = useState(0);

    const getMaxOrdre = (choix) => {
        let max = 0;
        choix.forEach(e => {
            if (e.ordre > max) {
                max = e.ordre;
            }
        });
        return max;
    }

    const selectId = (id) => {
        setCotisationIdSel(id);
        let filtered = choix.filter(el => el.cotisation_id === id);
        console.log('selectId :', id, filtered);
        // setMaxordre(getMaxOrdre(filtered));
        setChoixFiltered(filtered);

    }

    const handleModifChoix = (e) => {
        console.log('handleModifChoix', e);
        setChoixSel(e);
        setShowModifChoix(true);
    }

    const handleDelChoix = (e) => {
        if (window.confirm('Voulez-vous vraiment supprimer ce choix ?'))
            fetch(`${url}DelChoix/${e.id}`)
                .then(response => response.json())
                .then(data => {
                    console.log('DelChoix:', data);
                    getCotisations();
                })
                .catch(error => console.error('Erreur:', error));
    }

    const ajouteChoix = (id) => {
        selectId(id);
        setShowChoix(true);
    }

    const ExpandedComponent = ({ data }) => {

        let id = data.id;
        let myChoix = JSON.parse(data.choix);

        setMaxordre(getMaxOrdre(myChoix));

        return <Card>
            <Card.Header>Choix de cotisation</Card.Header>
            {/* <Card.Body> */}
            <Table striped bordered hover style={{ margin: 'auto', }}>
                <thead>
                    <tr>
                        {/* <th>Ordre</th> */}
                        <th>Libelle</th>
                        <th>Montant</th>
                        {data.trois_fois === 1 && <th>En 3 fois</th>}
                        {data.six_fois === 1 && <th>En 6 fois</th>}
                        <th>Modifier</th>
                        <th>Supprimer</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        myChoix.map((e) => (
                            <tr>
                                {/* <td>{e.ordre}</td> */}
                                <td>{e.libelle}</td>
                                <td>{e.montant}&nbsp;€</td>
                                {data.trois_fois === 1 && <td>{Math.ceil(e.montant / 3)}&nbsp;€</td>}
                                {data.six_fois === 1 && <td>{Math.ceil(e.montant / 6)}&nbsp;€</td>}
                                <td><Button variant="outline-secondary" onClick={() => handleModifChoix(e)}><FaPen /></Button></td>
                                <td>{1 !== e.choix_used && <Button variant="outline-danger" onClick={() => handleDelChoix(e)}><FaTrash /></Button>}</td>
                            </tr>
                        ))
                    }
                </tbody>
            </Table>
            <Button variant="outline-primary" onClick={() => ajouteChoix(id)} size='lg'>+</Button>
        </Card>
            // <pre>{JSON.stringify(data.choix, null, 2)}</pre>
            ;
    }

    const handleReload = () => {
        setShowChoix(false);
        setShowModifChoix(false);
        getCotisations();
    }
    return (
        <div>

            {/* <Button variant="secondary" onClick={() => setShowChoix(true)}>
                Nouveau choix
            </Button> */}

            <h1>Cotisations&nbsp;<Button variant="danger" onClick={() => setShow(true)}>+</Button></h1>
            <DataTable
                columns={columns}
                data={cotisationsFiltered}
                highlightOnHover
                subHeader
                subHeaderComponent={(
                    <>
                        <input
                            type="text"
                            value={searchText}
                            onChange={handleChangesearchText}
                            // onChange={(e) => setSearchText(e.target.value)}
                            placeholder="Rechercher..."
                        />
                        {searchText && <FaTimes className='h-5' onClick={() => filtre('', cotisations, feuilleParentSel)} />}
                    </>
                )}
                defaultSortField="id"
                defaultSortAsc={false}
                subHeaderAlign="left"
                noHeader={true}
                expandableRows
                expandableRowsComponent={ExpandedComponent}
            // onRowClicked={handleRowClick}
            />

            <GenerePdf fichier='feuille_vierge' data={data} go={goGenerePdf} setGo={setGoGenerePdf} visible={false} />

            <Modal size="xl" show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Nouvelle cotisation</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <CotisationNew closeModal={handleClose} getCotisations={getCotisations} cotisations={cotisations.filter(e=>e.parent===0)} />
                </Modal.Body>
            </Modal>

            <Modal size="xl" show={showUpdateCotisation} onHide={() => setShowUpdateCotisation(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Modifier la cotisation</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <CotisationModif closeModal={handleCloseUpdateCotisation} getCotisations={getCotisations} data={cotisationSel} cotisations={cotisations.filter(e=>e.parent===0)} />
                </Modal.Body>
            </Modal>

            <Modal size="xl" show={showChoix} onHide={() => setShowChoix(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Nouveau choix</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <CotisationChoixCreate choixCotisationIdSel={cotisationIdSel} maxordre={maxordre} handleReload={handleReload} />
                </Modal.Body>
            </Modal>

            <Modal size="xl" show={showModifChoix} onHide={() => setShowModifChoix(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Modification du choix</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <CotisationChoixModif handleReload={handleReload} data={choixSel} />
                </Modal.Body>
            </Modal>
            {/* <Modal size="xl" show={showNew} onHide={handleCloseNew}>
                <Modal.Header closeButton>
                    <Modal.Title>Nouvel article</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <NewArticle makeChange={makeChangeNew} init={true} nbArticle={adherentsLight.length} />
                </Modal.Body>
            </Modal> */}
        </div>
    );
}

export default CotisationGere;
